import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { setUserInfo } from '../actions/CommonAction';
import AuthRoute from '../routers/AuthRoute';
import Login from './common/LoginComponent';
import Error from './common/ErrorComponent';
import Contents from './Contents';
import { SYSTEM_ERROR_TYPE } from '../../common/const';
import PopMessage from './common/PopMessageComponent';
import PopPassword from './common/PopPasswordComponent';

class App extends Component {
  render() {
    const { systemErrorType, setUserInfoAct } = this.props;
    if (systemErrorType === SYSTEM_ERROR_TYPE.AUTH_NG) setUserInfoAct(null);
    return (
      <Router>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route exact path="/error" component={Error} />
          <AuthRoute path="/" component={Contents} />
        </Switch>
        <PopPassword />
        <PopMessage />
      </Router>
    );
  }
}

export default connect(
  (state) => ({
    systemErrorType: state.common.systemErrorType,
  }),
  (dispatch) => ({
    setUserInfoAct: (userInfo) => dispatch(setUserInfo(userInfo)),
  }),
)(App);
